module.exports = __webpack_public_path__ + "media/images/give-feedback-0fe76fedbce05e560baca11024708d9edc822c02b955ea4a4aa9dc290452d8d8.jpg";